<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.itcc_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.itcc_surname_buffer">
                      <el-input v-model="mData.tableRules.dataSearch.value.last_name" clearable></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item :label="aLang.itcc_name">
                      <el-input v-model="mData.tableRules.dataSearch.value.first_name" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.itcc_identity">
                      <el-input v-model="mData.tableRules.dataSearch.value.cmnd_number" clearable></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-row class="ml-0">
              <b-col md="3">
                <el-button @click="fn_handle('register')" type="warning" plain>{{aLang.itcc_title}}</el-button>
              </b-col>
              <b-col md="2">
                <el-button
                  @click="fn_exportExcel()"
                  type="info"
                  plain
                  :disabled="mData.dataDefault.countExports<=0"
                >{{aLang.c_exportExcel}}</el-button>
              </b-col>
              <b-col md="3">
                <el-select
                  v-model="mData.tableRules.dataSearch.value.reason"
                  @change="fn_changeData"
                  clearable
                >
                  <el-option
                    v-for="item in mData.dataDefault.selectValue"
                    :value="item.code"
                    :key="item.code"
                    :label="item.text"
                  ></el-option>
                </el-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
          :row-class-name="fn_checkErrorRow"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <el-table-column prop="selectedToExport" :label="aLang.itcc_choose" width="60" align="center">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.selectedToExport"
                @change="fn_changeSelectedToExport(scope.row.selectedToExport,scope.row)"
              ></el-checkbox>
            </template>
          </el-table-column>

          <el-table-column
            prop="last_name"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.itcc_surname_buffer"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="first_name"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.itcc_name"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="dob"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.itcc_bod"
            align="center"
            width="150"
          >
            <template slot-scope="scope">{{fn_formatterDobDate(scope.row.dob)}}</template>
          </el-table-column>
          <el-table-column
            prop="cmnd_number"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.itcc_identity"
            align="center"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="register_code"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.itcc_tourist_card_registration_code"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="card_code"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.itcc_card_number"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import MsKhachDuLichModel from "./MsKhachDuLichModel";
import MsKhachDuLichApi from "../../../moduleApi/MsKhachDuLichApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "MsKhachDuLich", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(MsKhachDuLichModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listExport: [],
          countExports: 0,
          selectValue: [
            {
              text: "Đã cấp mã",
              code: "true"
            },
            {
              text: "Chưa cấp mã",
              code: "false"
            }
          ]
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let stringFilter = "";
      if (this.mData.tableRules.filters.includes("reason:is_null:false")) {
        stringFilter = this.mData.tableRules.filters.replace(
          "reason:is_null:false",
          "reason:regex_m:[a-zA-Z]*"
        );
      } else {
        stringFilter = this.mData.tableRules.filters;
      }
      let dataFilter = {
        filters: stringFilter
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await MsKhachDuLichApi.list(dataFilter);
      // debugger
      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "register") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-register",
          params: {}
        });
      }
    },

    //delete
    async fn_delete(id) {
      await MsKhachDuLichApi.delete(id);
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search 
    fn_tableSearch() {
      if(this.mData.tableRules.dataSearch.value.last_name){
        this.mData.tableRules.dataSearch.value.last_name = this.mData.tableRules.dataSearch.value.last_name.trim();
      }
      if(this.mData.tableRules.dataSearch.value.first_name){
        this.mData.tableRules.dataSearch.value.first_name = this.mData.tableRules.dataSearch.value.first_name.trim();
      }
      if(this.mData.tableRules.dataSearch.value.cmnd_number){
        this.mData.tableRules.dataSearch.value.cmnd_number = this.mData.tableRules.dataSearch.value.cmnd_number.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_changeSelectedToExport(selectedValue, cellValue) {
      // debugger
      if (selectedValue == true) {
        this.mData.dataDefault.countExports++;
        this.mData.dataDefault.listExport.push(cellValue);
      } else {
        this.mData.dataDefault.countExports--;
        this.mData.dataDefault.listExport = this.mData.dataDefault.listExport.filter(
          function(obj) {
            return obj.id != cellValue.id;
          }
        );
      }
    },

    fn_exportExcel() {
      MethodService.exportExcel(this.mData.dataDefault.listExport);
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterDobDate(cellValue) {
      let ngay = cellValue.toString().substring(6, 8);
      let thang = cellValue.toString().substring(4, 6);
      let nam = cellValue.toString().substring(0, 4);
      return ngay + "/" + thang + "/" + nam;
      // return MethodService.formatDate(ngay, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {},

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_checkErrorRow(row) {
      if (row.row.reason) {
        return "error-row";
      } else {
        return "";
      }
    },
    fn_changeData() {
      this.mData.tableRules.filters = MethodService.filterTable(
        JSON.stringify(this.mData.tableRules.dataSearch)
      );
      this.mData.tableRules.offset = 0;
      this.mData.tableRules.sort = "";
      this.fn_initTable();
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
<style lang="scss">
.el-table .error-row {
  background-color: oldlace !important;
}
</style>
